import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HistoryItem } from '@reflact/ipkv-types';
import { firstValueFrom } from 'rxjs';
import { Api } from '../../api';
import { SocketService } from '../../socket.service';
import { PasteTrackingService } from '../../paste-tracking.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  public selectedTeilaufgabeTable?: number;
  public selectedHistoryItems: HistoryItem[] = [];
  public userInputEnabled: boolean = true;

  constructor(protected socketService: SocketService, protected api: Api, protected http: HttpClient, private pasteTracking: PasteTrackingService) {
    this.api.fallaufgabenStatusSubject.subscribe((s) => { this.updateSelectedHistoryItems() });
    void this.initSockets();
  }

  public upsertHistoryItemContents(h: HistoryItem) {
    const existingItem = this.api.fallaufgabeStatus?.chatHistoryItems.find(i => i._id == h._id);
    console.log('upsertHistoryItemContents', existingItem)
    if (existingItem) {
      existingItem.content = h.content;
    } else {
      this.api.fallaufgabeStatus?.chatHistoryItems.push(h);
      this.updateSelectedHistoryItems();
    }
  }

  private async initSockets() {
    this.updateSelectedHistoryItems();
    const io = await this.socketService.getIo()

    io.on("selectAufgabe", (aufgabenId, assistantMsg) => {
      this.selectedTeilaufgabeTable = undefined;
      this.api.fallaufgabeStatus!.userSelectedAufgabenId = aufgabenId;
      if (assistantMsg) {
        this.upsertHistoryItemContents(assistantMsg);
      } else {
        this.updateSelectedHistoryItems('instant');
      }
    });

    io.on("teilAufgabeAnswered", (solution) => {
      this.api.getCurrentSolutions();
    });

    io.on("runUpdate", (h) => {
      this.upsertHistoryItemContents(h);
      const dialog = document.getElementById("dialog");
      if (!dialog) return;
      dialog.scroll({
        top: dialog.scrollHeight,
        behavior: "smooth"
      });
    });

    io.on("stateUpdate", (s) => {
      if (s == "idle") {
        this.userInputEnabled = true;
      } else {
        this.userInputEnabled = false;
      }
      const dialog = document.getElementById("dialog");
      if (!dialog) return;
      dialog.scroll({
        top: dialog.scrollHeight,
        behavior: "smooth"
      });
    });

    io.on("runComplete", (h) => {
      console.log("runComplete", h)
      this.upsertHistoryItemContents(h);
    });
  }

  public updateSelectedHistoryItems(behavior: ScrollBehavior | undefined = 'smooth') {
    const status = this.api.fallaufgabeStatus;
    if (status == null) {
      this.selectedHistoryItems = [];
      return
    }
    this.selectedHistoryItems = status.chatHistoryItems.filter((h) => {
      return !h.bypass && h.aufgabenId == status!.userSelectedAufgabenId
    })
    setTimeout(() => {
      const dialog = document.getElementById("dialog");
      if (!dialog) return;
      dialog.scroll({
        top: dialog.scrollHeight,
        behavior
      });
    }, 100)
  };

  public async selectAufgabe(aufgabenId: string | null) {
    this.selectedTeilaufgabeTable = undefined;
    return await firstValueFrom(this.http.post('api/interact/selectaufgabe', { aufgabenId }));
  }

  public async chat(userInput: string) {
    if (!this.userInputEnabled) { return }
    this.userInputEnabled = false;
    const inputMetadata = this.pasteTracking.getAndResetDelta();
    const result = await firstValueFrom(this.http.post<{ msg: string, historyItem: HistoryItem }>('api/interact/chat', { userInput, inputMetadata }));
    this.api.fallaufgabeStatus?.chatHistoryItems.push(result.historyItem);
    return result;
  }

  public async addMessage(content: string, role: string) {
    const result = await firstValueFrom(this.http.post<{ msg: string, historyItem: HistoryItem }>('api/interact/addMessage', { content, role }));
    this.api.fallaufgabeStatus?.chatHistoryItems.push(result.historyItem);
    this.updateSelectedHistoryItems();
  }
}